import { result } from "lodash";
import { prjPhotoSlick } from "./fjk.projects.indevidual.slick";

// data format
//   {
//     "id": 1,
//     "uid": "cat_4_1",
//     "category_id": "cat_4",
//     "category_code": "commercial",
//     "category_label": "店舗・アミューズメント",
//     "classification": "",
//     "name": "ROUND 1 尼崎店　外装工事・サイン工事",
//     "status": true,
//     "year": 2007,
//     "place": "尼崎市",
//     "structure": "建物の構造などスペックに関する記述",
//     "comment": "コメントが入ります。コメントが入ります。コメントが入ります。コメントが入ります。",
//     "note": "",
//     "photos": {
//       "count": 1,
//       "thumbnail": "/assets/project_photos/p01_thumb.jpg",
//       "main": "/assets/project_photos/p00.jpg",
//       "sub": [
//         "/assets/project_photos/p01.jpg",
//         "/assets/project_photos/p02.jpg",
//         "/assets/project_photos/p03.jpg",
//         "/assets/project_photos/p04.jpg",
//         ""
//       ]
//     }
//   }

export function renderProjectDetail(dataObj) {
  const data = dataObj;
  // console.log(data)

  // selector

  // meta 情報

  let meta_title = $("html head title").text()
  let regex_title = /- (.+?) \|/;
  $("html head title").text(
    meta_title.replace(regex_title, `- ${data.category_label} ${data.name} |`)
  );

  // パンリンク


    let clumb_item = $(".clumblink__list .clumblink__listitem");
    let clumb_item_length = $(clumb_item).length;
    // console.log(clumb_item)
    $(clumb_item[clumb_item_length - 1]).html(
      `<a href="${data.path}">${data.name}</a>`
    );
    $(clumb_item[clumb_item_length - 2]).html(
      `<a href="/projects/${data.category_code}/">${data.category_label}</a>`
    );


  // header
  const prj_header = $(".prj__section__header");

  // name
  prj_header.find(".prj__name").text(data.name);
  prj_header.find(".prj__category").text(data.category_label);

  // related items
  const related_header = $(".project_related_head");
  related_header
    .find("p")
    .html(" <p>「" + data.category_label + "」に関するその他の事例</p>");

  // // overview

  // let overview_html = `<table class="table-overview u_table"><tbody>`;

  //   if (data.place) {
  //     overview_html += `<tr><th>施工場所</th><td>${data.place}</td></tr>`;
  //   }

  // if (data.year) {
  //   overview_html += `<tr><th>竣工</th><td>${data.year}年</td></tr>`;
  // }
  // if (data.category_label) {
  //   overview_html += `<tr><th>施設カテゴリ</th><td>${data.category_label}</td></tr>`;
  // }


  // if (data.structure) {
  //   overview_html += `<tr><th>工事区分</th><td>${data.structure}</td></tr>`;
  // }
  // if (data.comment) {
  //   overview_html += `<tr><th>工事概要</th><td>${data.comment}</td></tr>`;
  // }

  // overview_html += `</tbody></table>`;

  // $(".prj__detail table").html(overview_html);

  // const photo_area = $(".prj__photos");

  // if (data.photos.count > 0) {
  //   const loop_no = data.photos.count;
  //   for (let i = 0; i < loop_no; i++) {
  //     const photo_no = i + 1;
  //     const photo_file_no = ("00" + photo_no).slice(-2);
  //     const photo_obj = `${data.uid}__p${photo_file_no}.jpg`;
  //     console.log(photo_obj);

  //     photo_area
  //       .find(".photo_main")
  //       .append(
  //         `<div class="photo_main_item"><img src="/assets/img/projects/photos/${photo_obj}" alt=""></div>`
  //       );
  //     photo_area
  //       .find(".photo_sub")
  //       .append(
  //         `<div class=" photo_sub_item"><img src="/assets/img/projects/photos/${photo_obj}" alt=""></div>`
  //       );
  //   }


  // }

  console.log(dataObj);
  
}
$(window).on("load", function () {
  prjPhotoSlick();
  // console.log("prjPhotoSlick");
});

export function isEmbedData(){
  const embed_data = $("#pagedata").data()
  
  const result = {
    flag: embed_data ? true : false,
    data: embed_data
  };

  // console.log("embeddata",result)
  return result;
}

